<style lang="less" scoped>
  .name {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
</style>
<template>
  <v-menu
    v-if="customer.id"
    :close-on-content-click="false"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
      >
        <slot :item="customer">
          <span class="name">{{ customer.account }}</span>
        </slot>
      </span>
    </template>
    <v-card
      width="360"
      style="padding: 0 12px"
    >
      <v-row
        align="center"
      >
        <v-col cols="2">
          <v-avatar
            size="50"
            color="indigo"
          >
            <v-img
              v-if="customer.avatar"
              alt="Avatar"
              :src="customer.avatar"
            />
            <span
              v-else
              style="font-size: 70px; color: white"
            >
              {{ account_first_char }}
            </span>
          </v-avatar>
        </v-col>
        <v-col cols="3">
          <div class="text-bold">
            {{ customer.account }}
          </div>
          <small
            v-if="customer.quit"
            class="color-grey"
          >
            离职
          </small>
          <small
            v-if="is_financer && is_formal"
            class="text--darken-3"
          >
            - {{ customer_type_name }}
          </small>
        </v-col>
        <v-col>
          <div>{{ customer.team_name || '无团队' }}</div>
          <div>{{ customer.email }}</div>
        </v-col>
      </v-row>
    </v-card>
  </v-menu>
  <span v-else>无</span>
</template>
<script>
  import CustomerUtil from './libs/util';
  import CustomerCard from './card';
  import {mapGetters} from "vuex";

  export default {
    components: { CustomerCard },
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        loading: false,
        failed: false,
        customer: {}
      }
    },
    computed: {
      account_first_char() {
        const first = this.customer.account.toString().slice(0, 1);
        return first || '-';
      },
      ...mapGetters(['is_financer']),
      ...mapGetters('async', ['cur_customer', 'customer_types_hash']),
      is_formal() {
        return this.cur_customer.is_formal;
      },
      customer_type_name() {
        const type = this.customer_types_hash[this.customer.customer_type];
        return type ? type.label : '-';
      }
    },
    watch: {
      id() {
        this.init();
      }
    },
    created() {
      this.init();
    },
    mounted() {
      //
    },
    methods: {
      async init() {
        if (!this.id) return;
        if (this.loading) return;
        this.loading = true;
        this.customer = await CustomerUtil.briefInfo(this.id);
        this.customer = this.customer || {}
        this.loading = false;
      }
    }
  }
</script>
